export const actionTypes = {
  REQUEST_START: 'MESSAGES.FEEDBACK_QUESTIONS.REQUEST_START',
  REQUEST_SUCCESS: 'MESSAGES.FEEDBACK_QUESTIONS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MESSAGES.FEEDBACK_QUESTIONS.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
